import React, { Fragment, useEffect, useState } from "react";
import { ReactComponent as SearchIcon } from "assets/images/common/svgs/search.svg";
import { ReactComponent as DeleteIcon } from "assets/images/common/svgs/deleteIconTable.svg";
import { ReactComponent as EyeIcon } from "assets/images/common/svgs/eyeIconTable.svg";
import { ReactComponent as NotificationRedIcon } from "assets/images/common/svgs/notificationRedIcon.svg";
import { ReactComponent as AmbassadorIocn } from "assets/images/common/svgs/AmbassadorIocnTable.svg";
import { ReactComponent as AttendeIcon } from "assets/images/common/svgs/AttendeeIocnTable.svg";
import { ReactComponent as HostIcon } from "assets/images/common/svgs/HostIocnTable.svg";
import { ReactComponent as InforCircle } from "assets/images/common/svgs/ToolTipIcon.svg";
import { ReactComponent as InfoTipSvg } from "assets/images/common/svgs/info-tip.svg";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";

import { ReactComponent as TickGreenIcon } from "assets/images/common/svgs/TickGreenSvg.svg";
import { ReactComponent as EditPenIcon } from "assets/images/common/svgs/editPenIcon.svg";

import useOutsideClick from "hooks/click-outside-hook";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import { useNavigate } from "react-router-dom";
import { confirmationPopup } from "utils/helpers/common/alert-service";
import useUsers from "containers/user-management/useHooks";
import {
  SubscribersFiltersDTO,
  UserFiltersDTO,
} from "utils/helpers/models/common/user-filters.dto";
import Pagination from "components/particles/table/pagination";
import { ROLES } from "utils/helpers/enums/roles.enum";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";
import { ManageSubscriptionDummyData } from "components/dummy-data";
import SubscriptionPlanModal from "../component/subscription-plan-modal";
import { useDebounce } from "hooks/useDebounce";
import { SUBSCRIBER_STATUSES } from "utils/helpers/enums/shared.enum";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

const bgColorMap: Record<string, string> = {
  "Basic Membership": "bg-lightBlueBg",
  "Premium Membership": "bg-softLavenderBg",
  "Next level membership": "bg-parchmentBg",
};

const textColorMap: Record<string, string> = {
  "Basic Membership": "text-vibrantBlueText",
  "Premium Membership": "text-vibrantPurpleText",
  "Next level membership": "text-goldenAmberText",
};

const SubscriptionListing: React.FC = () => {
  const navigate = useNavigate();
  const columns: string[] = [
    "Profile",
    "First Name",
    "Last Name",
    "Plan",
    "Status",
    "Start Date",
    "Next Billing",
    "Amount",
    // "Action",
  ];
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);

  const openSubscriptionModal = () => setIsSubscriptionModalOpen(true);
  const closeModals = () => {
    setIsSubscriptionModalOpen(false);
  };

  const [data, setData] = useState<any[]>([]);
  const [subscribers, setSubscribers] = useState<any[]>([]);

  const { getSubscribers, getSubscriptionPlan } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [filters, setFilters] = useState<SubscribersFiltersDTO>(
    new SubscribersFiltersDTO()
  );

  // const modalRef = useOutsideClick(() => setIsModalOpen(false));

  const buildUpdatedFilters = (
    updates: Partial<SubscribersFiltersDTO> = {},
    resetPage: boolean = false
  ) => {
    const updatedFilters = { ...filters, ...updates };
    if (resetPage) {
      updatedFilters.page = 1;
    }
    return updatedFilters;
  };

  useEffect(() => {
    getSubscriptionPlan(setData);
  }, []);

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    const updatedFilters = buildUpdatedFilters(
      { limit: limit, page: page + 1 },
      false
    );
    setFilters(updatedFilters);
    getAllSubscribers(updatedFilters);
  };

  const getAllSubscribers = (filters: SubscribersFiltersDTO) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
        filtersToSend[key] = filters[key];
      }
    }
    const queryParams = {
      ...filtersToSend,
      page: filters.page - 1,
    };
    getSubscribers(setSubscribers, queryParams, setFilters, setTotalElements);
  };

  useEffect(() => {
    getAllSubscribers(filters);
  }, []);

  const handleChangeFilter = (event: any) => {
    const {
      target: { name, value },
    } = event;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const updatedFilters = buildUpdatedFilters(
      { [name]: trimmedValue },
      true
    );
    setFilters(updatedFilters);
    if (name === "firstName" && trimmedValue === "") {
      getAllSubscribers(updatedFilters);
    }
  };

  const resetFilters = () => {
    const updatedFilters = buildUpdatedFilters(new SubscribersFiltersDTO(), true);
    setFilters(updatedFilters);
    getAllSubscribers(updatedFilters);
  };

  const handleSearch = (event: any) => {
    const { key } = event;
    if (key === "Enter") {
      const updatedFilters = buildUpdatedFilters({}, true);
      setFilters(updatedFilters);
      getAllSubscribers(updatedFilters);
    }
  };

  console.log(subscribers, "subscribers");

  return (
    <div className="">
      <h1 className="tex-2xl sm:text-[32px] text-primaryText font-bold mb-6">
        Subscription Plans
      </h1>

      <div className="bg-coolLightGrayBg border  border-borderLightGray  rounded-lg w-full my-6">
        <h1 className="text-lg text-primaryText font-medium p-6 border-b border-borderLightGray">
          Subscription Plans
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-6">
          {data.map((plan: any, index: number) => (
            <div
              key={index + 1}
              className="border border-borderLightGray rounded-md"
            >
              <div
                className={`flex justify-between gap-4 items-center rounded-t-md p-4 ${
                  bgColorMap[plan.name] || "bg-gray-100"
                }`}
              >
                <p
                  className={`text-base font-medium ${
                    textColorMap[plan.name] || "text-gray-700"
                  }`}
                >
                  {plan?.name}
                </p>
                {/* <span className={`px-4 py-2 text-xs rounded-full ${plan.tagColor}`}>
                  {plan.tagText}
                </span> */}
              </div>
              <div className="p-4 border-t border-lightGrayBorder">
                <p className="text-darkGrayText text-2xl font-bold">
                  ${plan?.price}
                  <span className="text-base text-uiGrayText font-normal ml-1">
                    /month
                  </span>
                </p>
                <ul className="space-y-2 my-3">
                  {(
                    (plan.name === "Basic Membership" && [
                      "Badge (not customizable) - pick one",
                      "Host limited to 2 sessions per month",
                    ]) ||
                    (plan.name === "Premium Membership" && [
                      "Gold level badge with customized centre (can upload logo or pic)",
                      "Unlimited sessions per month",
                      "May post workshop with 10% learn local fee",
                    ]) ||
                    (plan.name === "Next level membership" && [
                      "Silver level badge with customized centre (can upload logo or pic)",
                      "Unlimited sessions per month",
                      "May post workshop but learn local will collect 10% fee of what the host charges",
                    ]) ||
                    []
                  ).map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <TickGreenIcon className="min-w-4" />
                      <p className="text-sm text-primaryText">{feature}</p>
                    </li>
                  ))}
                </ul>

                <div className="flex justify-between gap-4 items-center ">
                  <p className="text-uiGrayText text-base font-medium">
                    {plan?.subscriptionsCount} subscribers
                  </p>
                  {/* <span
                    onClick={() => setIsSubscriptionModalOpen(true)}
                    className="cursor-pointer"
                  >
                    <EditPenIcon />
                  </span> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-coolLightGrayBg border  border-borderLightGray p-4 rounded-lg w-full">
        <div className="flex justify-end items-center flex-wrap gap-3">
          <select
            value={filters.status}
            onChange={handleChangeFilter}
            name="status"
            className="px-3 border border-lightGrayBorder text-primaryText outline-none rounded-lg text-sm bg-white h-[46px] w-full md:w-auto min-w-[140px]"
          >
            <option value="">Status</option>
            {Object.values(SUBSCRIBER_STATUSES).map((status, index) => {
              return (
                <option value={status} key={index}>
                  {status.toUpperCase()}
                </option>
              );
            })}
          </select>

          <button
            onClick={() => {
              const updatedFilters = buildUpdatedFilters({}, true);
              setFilters(updatedFilters);
              getAllSubscribers(updatedFilters);
            }}
            className="px-4 py-2 bg-darkTealBlue text-white rounded-lg text-sm h-[46px] w-full md:w-auto min-w-[140px]"
          >
            Apply Filters
          </button>

          {/* Clear Filters Button */}
          <button
            onClick={resetFilters}
            className="px-4 py-2 bg-techGlowBg text-primaryText rounded-lg text-sm h-[46px] w-full md:w-auto min-w-[140px]"
          >
            Clear Filter
          </button>
        </div>
      </div>

      <div className="w-full flex flex-col gap-4  my-6">
        <div className="bg-white rounded-t-lg  border border-mediumGrayBorder overflow-x-auto">
          <table className="min-w-full divide-y divide-mediumGrayBorder">
            {/* Table Header */}
            <thead className="bg-white">
              <tr className="text-left">
                {columns.map((column, index) => {
                  return (
                    <th
                      className="px-4 py-4 text-sm font-bold text-left text-primaryText whitespace-nowrap"
                      key={index}
                    >
                      {column}
                    </th>
                  );
                })}
              </tr>
            </thead>

            {/* Table Body */}
            <tbody className="bg-white divide-y divide-mediumGrayBorder">
              {subscribers.map((user: any, index: number) => (
                <tr key={index + 1} className="hover:bg-gray-50 ">
                  <td className="px-4 py-4">
                    <img
                      className="rounded-full w-9 h-9 object-cover"
                      src={
                        user?.profilePicUrl
                          ? concatPathWithBackendUrl(
                              user?.profilePicUrl?.fileDownloadUri
                            )
                          : editProfilePicUser
                      }
                      alt={user.Profile}
                    />
                  </td>
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {user?.firstName}
                  </td>
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {user?.lastName}
                  </td>
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {user?.product?.name}
                  </td>
                  <td className="px-4 py-4 text-sm font-semibold whitespace-nowrap">
                    {user?.status}
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {user?.currentPeriodStart
                      ? new Date(user.currentPeriodStart).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }
                        )
                      : "N/A"}
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {user?.currentPeriodEnd
                      ? new Date(user.currentPeriodEnd).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }
                        )
                      : "N/A"}
                  </td>

                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {user?.product?.price}
                  </td>

                  {/* <td className="px-4 py-4 text-left whitespace-nowrap w-[124px]">
                    <div className="flex justify-start gap-2 ">
                      <button
                        onClick={() => {
                          navigate(siteRoutes.hostSubscribers);
                        }}
                        className=""
                      >
                        <EyeIcon />
                      </button>
                    </div>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Fragment>
          <DataNotFound show={!isLoading && !data.length} />
          {totalElements > 0 && (
            <Pagination
              count={totalElements}
              page={filters.page}
              limit={filters.limit}
              onPageChange={onPageChange}
            />
          )}
        </Fragment>
      </div>
      {isSubscriptionModalOpen && (
        <SubscriptionPlanModal
          isOpen={isSubscriptionModalOpen}
          onClose={closeModals}
        />
      )}
    </div>
  );
};

export default SubscriptionListing;
